(function() {
    const registerDatePlugin = () => {
        if ($.fn.dataTable && $.fn.dataTable.render) {
            $.fn.dataTable.render.moment = function ( from, to, locale ) {
                if ( arguments.length === 1 ) { 
                    locale = 'en'; to = from; from = 'YYYY-MM-DD'; 
                }
                return function ( d, type, row ) {
                    if (!d) return d;
                    var m = window.moment( d, from, locale, true );
                    if ( ! m.isValid() ) return d;
                    // Sort by timestamp, display by format
                    return m.format( type === 'sort' || type === 'type' ? 'x' : to );
                };
            };
        }
    };

    registerDatePlugin();
    $(document).on('turbolinks:load', registerDatePlugin);
})();
